import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShoppingCart = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_425_2863",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 40,
		height: 40,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_425_2863)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M11.8551 36.6389C10.998 36.6389 10.2661 36.3337 9.65967 35.7233C9.05317 35.1129 8.74992 34.3791 8.74992 33.5219C8.74992 32.6648 9.05513 31.9329 9.66554 31.3265C10.276 30.72 11.0098 30.4167 11.8669 30.4167C12.7241 30.4167 13.4559 30.7219 14.0624 31.3323C14.6689 31.9427 14.9721 32.6765 14.9721 33.5337C14.9721 34.3909 14.6669 35.1227 14.0565 35.7292C13.4461 36.3357 12.7123 36.6389 11.8551 36.6389ZM28.5218 36.6389C27.6646 36.6389 26.9328 36.3337 26.3263 35.7233C25.7198 35.1129 25.4166 34.3791 25.4166 33.5219C25.4166 32.6648 25.7218 31.9329 26.3322 31.3265C26.9426 30.72 27.6764 30.4167 28.5336 30.4167C29.3908 30.4167 30.1226 30.7219 30.7291 31.3323C31.3356 31.9427 31.6388 32.6765 31.6388 33.5337C31.6388 34.3909 31.3336 35.1227 30.7232 35.7292C30.1128 36.3357 29.379 36.6389 28.5218 36.6389ZM9.94433 9.41671L14.3333 18.5278H26.2222L31.2222 9.41671H9.94433ZM8.58325 6.63892H33.1408C33.7791 6.63892 34.2647 6.92828 34.5977 7.507C34.9306 8.08569 34.9351 8.66671 34.611 9.25004L28.8888 19.5556C28.5832 20.0926 28.1822 20.5185 27.6858 20.8334C27.1893 21.1482 26.6459 21.3056 26.0555 21.3056H13.4999L11.3333 25.3056H30.2499C30.6434 25.3056 30.9733 25.4392 31.2395 25.7063C31.5057 25.9734 31.6388 26.3045 31.6388 26.6994C31.6388 27.0943 31.5057 27.4237 31.2395 27.6875C30.9733 27.9514 30.6434 28.0834 30.2499 28.0834H11.5833C10.3888 28.0834 9.51381 27.6413 8.95825 26.757C8.4027 25.8727 8.39807 24.926 8.94438 23.9167L11.4722 19.2778L5.24992 6.11112H3.36104C2.96752 6.11112 2.63765 5.97756 2.37146 5.71042C2.10527 5.44328 1.97217 5.11226 1.97217 4.71737C1.97217 4.32249 2.10527 3.9931 2.37146 3.72921C2.63765 3.46532 2.96752 3.33337 3.36104 3.33337H6.15271C6.42121 3.33337 6.66843 3.40221 6.89438 3.53987C7.12029 3.67757 7.28974 3.87262 7.40271 4.12504L8.58325 6.63892Z",
			fill: "#778521"
		})
	})]
});
export default SvgShoppingCart;
